import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_PROJECT_APP_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PROJECT_PUBLISHABLE_KEY;

const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

export default supabase;